export default __webpack_public_path__ + "static/media/img_set.04899483.png";